function globalCss() {
  const styles = `
    *,
    *:before,
    *:after {
      box-sizing: border-box;
    }

    html {
      height: 100%;
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }

    .text-left {
      text-align: left;
    }

    .text-right {
      text-align: right;
    }
  `;
  return {
    hid: 'global-css',
    innerHTML: styles
  };
}
export { globalCss };